import { useAppSelector } from '../redux/hooks';

const useSubscriptionAccess = () => useAppSelector((state) => state.subscription.value.access);

export default useSubscriptionAccess;
